import { takeLatest } from 'redux-saga/effects';
import {
  getMyProfileSuccess, getMyProfileFail
} from './myProfileState';
import createCrudService from '../../services/crudservice';
import { doCrudCall, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
	updateRecordSuccess, deleteRecordSuccess 
	} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/my/profile');
const redirectData = {route:'/my/profile', mode: 'list', recordId:0 };
const modelName = 'Profile';
const modelId = 'id';

function* getMyProfile() {
	yield doCrudCall(
		() => crudService.getDetails(), 
		getMyProfileSuccess, 
		getMyProfileFail,
		null, null, LOADING_MSG);		
}

function* doMyProfileUpdate(data){
	yield doCrudCall(
		() => crudService.doPostRequest('update', data.payload), 
		getMyProfileSuccess, 
		getMyProfileFail,
		updateRecordSuccess(modelName),
		redirectData, UPDATING_MSG);	
}

function* doMyProfileDelete(data){
	yield doCrudCall(
		() => crudService.doDelete(data.payload.recordId), 
		getMyProfileSuccess, 
		getMyProfileFail,
		deleteRecordSuccess(modelName),
		{...redirectData, mode: data.payload.mode},
		DELETING_MSG);	
}


function* myProfileSaga() {
  yield takeLatest('myProfile/getMyProfile', getMyProfile);
  yield takeLatest('myProfile/doMyProfileUpdate', doMyProfileUpdate);
  yield takeLatest('myProfile/doMyProfileDelete', doMyProfileDelete);  
}

export default myProfileSaga;
